// Campus photo for /colleges/university-of-north-texas: CC BY-SA 4.0, by Michael Barera, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUniversity_of_North_Texas_September_2015_11_(Hurley_Administration_Building).jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-north-texas/; credited under the photo.
const photo = {
    "slug": "university-of-north-texas",
    "alt": "The Hurley Administration Building and its clock tower seen past a reflecting pool on the University of North Texas campus in Denton, Texas",
    "src": "/colleges/university-of-north-texas/campus-1600.webp",
    "srcSmall": "/colleges/university-of-north-texas/campus-800.webp",
    "srcMid": "/colleges/university-of-north-texas/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-north-texas/og.jpg",
    "title": "University of North Texas September 2015 11 (Hurley Administration Building)",
    "author": "Michael Barera",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUniversity_of_North_Texas_September_2015_11_(Hurley_Administration_Building).jpg",
    "read": "2026-10-01"
};

export default photo;
